/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component, createContext } from 'react';
import { View } from 'react-native';

type Props = {
  alignHorizontal?: boolean;
  style?: StyleSet;
  selectedValue: unknown;
  onChange: (value: unknown) => void;
};

type Context = {
  name: string;
  selectedValue: unknown;
  onChange: (value: unknown) => void;
} | void;

export const RadioContext = createContext<Context>(null as any);

let count = 0;

class RadioGroup extends Component<Props> {
  _name = 'radio-' + getSalt() + '-' + (count += 1);

  render() {
    let {
      alignHorizontal,
      onChange,
      selectedValue,
      style,
      ...otherProps
    } = this.props;
    let contextData = {
      name: this._name,
      selectedValue,
      onChange,
    };
    return (
      <RadioContext.Provider value={contextData}>
        <View
          style={[
            alignHorizontal && { flexDirection: 'row', flexWrap: 'wrap' },
            style,
          ]}
          {...otherProps}
        />
      </RadioContext.Provider>
    );
  }
}

function getSalt() {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(36);
}

export default RadioGroup;
